import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Counter } from '../../models/counter';
import { GroupEventOrder } from '../../../order/models/group-event-order';
import { BookingService } from '../../services/booking.service';
import { BookingStepService } from '../../services/booking-step.service';
import { BookingStepEnum } from '../../models/booking-step.enum';
import { NgForm } from '@angular/forms';
import { LocalizationService } from '../../../../services/localization.service';
import { Moment } from '../../../../../../node_modules/moment';
import { LoadingSpinnerService } from '../../../../services/loading-spinner.service';
import { NotificationService } from '../../../general/services/notification.service';

@Component({
  selector: 'app-booking-group-event',
  templateUrl: './booking-group-event.component.html',
  styleUrls: ['./booking-group-event.component.css']
})
export class BookingGroupEventComponent implements OnInit, OnDestroy {

  name_of_organization: string;
  surname_of_contact: string;
  name_of_contact: string;
  street: string;
  zip: string;
  phone: string;
  email: string;
  date: Moment;
  time: string;
  other_info: string;
  guestCount: Counter;

  private _formProcessing = false;

  constructor(
    private bookingService: BookingService,
    private bookingStepService: BookingStepService,
    private localizationService: LocalizationService,
    private loadingSpinnerService: LoadingSpinnerService,
    private notificationService: NotificationService,
  ) {
    this.guestCount = new Counter(0, 15, null, null, 70, 15);
  }

  @ViewChild(NgForm, { static: true }) form;

  ngOnInit(): void {
  }

  get isFormValid(): boolean {
    return this.form.valid;
  }

  get formProcessing(): boolean {
    return this._formProcessing;
  }

  onSend(): void {
    if (
      this.isFormValid && !this._formProcessing
    ) {

      this.loadingSpinnerService.show();
      this._formProcessing = true;

      const groupEventOrder = new GroupEventOrder();
      groupEventOrder.nameOfOrganization = this.name_of_organization;
      groupEventOrder.surnameOfContact = this.surname_of_contact;
      groupEventOrder.nameOfContact = this.name_of_contact;
      groupEventOrder.street = this.street;
      groupEventOrder.phone = this.phone;
      groupEventOrder.email = this.email;
      groupEventOrder.zip = this.zip;
      groupEventOrder.date = this.localizationService.formatDate(this.date.toDate()) + ' // ' + this.time;
      groupEventOrder.otherInfo = this.other_info;
      groupEventOrder.guestCount = this.guestCount.count;

      this.bookingService.sendGroupEventOrder(groupEventOrder).subscribe(
        result => {
          this._formProcessing = false;
          this.bookingStepService.update(BookingStepEnum.GroupEventThankYou);
          this.loadingSpinnerService.hide();
        },
        error => {
          this._formProcessing = false;
          this.notificationService.show(BookingGroupEventComponent.name, 'Error during sending mail');
          this.loadingSpinnerService.hide();
        });
    }
  }

  ngOnDestroy(): void {
    this.notificationService.hide(BookingGroupEventComponent.name);
  }
}
